'use client';

import { API_ROUTES, useApiQuery } from '@shared/api-utils';

type VerificationType = 'EMAIL' | 'PHONE';
type VerificationStatus = 'VERIFIED' | 'FAILED' | 'PENDING';

type KycVerification = {
  type: VerificationType;
  status: VerificationStatus;
};

type KycCardResponse = {
  verifications: KycVerification[];
};

type VerificationStatusResult = {
  isEmailVerified: boolean;
  isMobileVerified: boolean;
  isLoading: boolean;
  isFetching: boolean;
  isError: boolean;
  refetch: () => void;
};

function useVerificationStatus(): VerificationStatusResult {
  const { data, isLoading, isFetching, isError, refetch } = useApiQuery<KycCardResponse>(API_ROUTES.PLAYER_KYC.VERIFICATION.KYC_CARD, { credentials: true });

  const verifications = data?.verifications ?? [];

  const isVerified = (type: VerificationType) => verifications.some(verification => verification.type === type && verification.status === 'VERIFIED');

  return {
    isEmailVerified: isVerified('EMAIL'),
    isMobileVerified: isVerified('PHONE'),
    isLoading,
    isFetching,
    isError,
    refetch: () => void refetch(),
  };
}

export { useVerificationStatus };
export type { KycCardResponse, KycVerification };
